import { render, staticRenderFns } from "./SeleccionarAbonos.vue?vue&type=template&id=067c2a58"
import script from "./SeleccionarAbonos.vue?vue&type=script&lang=js"
export * from "./SeleccionarAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports